import { COLUMN_TYPES } from "../../../constants/common";
import { SystemUsersEnum } from "../../../constants/SystemUsers";

export const NO_RECORDS_MESSAGE = "No records found for the selected date range.";

export const AD_PERFORMANCE_REPORT_NAME = "Ad Performance Report";

export const adReportFilterOptions = [
  {
    field: "position",
    label: "Position",
    options: [
      { name: "Top", value: "Top" },
      { name: "Featured", value: "Featured" },
    ],
  },
  {
    field: "payment",
    label: "Payment",
    options: [
      { name: "Draft", value: "Draft" },
      { name: "Purchased", value: "Purchased" },
    ],
  },
  {
    field: "status",
    label: "Status",
    options: [
      { name: "Active", value: "Active" },
      { name: "Inactive", value: "Inactive" },
      { name: "Expired", value: "Expired" },
    ],
  },
];

export const adPerformanceColumns = [
  { fieldName: "bannerName", label: "Banner Name", isSelected: true, type: COLUMN_TYPES.BASIC, width: 190, sort: true },
  { fieldName: "distributorName", label: "Distributor", isSelected: true, type: COLUMN_TYPES.BASIC, width: 190, sort: true, adminOnly: true },
  { fieldName: "position", label: "Position", isSelected: true, type: COLUMN_TYPES.BASIC, width: 120, sort: true },
  { fieldName: "campaignStartDate", label: "Campaign Dates", isSelected: true, type: COLUMN_TYPES.BASIC, width: 190, sort: true },
  { fieldName: "adStatus", label: "Status", isSelected: true, type: COLUMN_TYPES.BASIC, width: 120, sort: true },
  { fieldName: "totalClicks", label: "Clicks", isSelected: true, type: COLUMN_TYPES.BASIC, width: 100, sort: false },
  { fieldName: "targetDevices", label: "Target Devices/OS", isSelected: true, type: COLUMN_TYPES.BASIC, width: 190, sort: false, },
  { fieldName: "byTargetDevicesClick", label: "M / T / W", isSelected: true, type: COLUMN_TYPES.BASIC, width: 190, sort: false, },
  { fieldName: "amountCharged", label: "Amount Charged", isSelected: true, type: COLUMN_TYPES.BASIC, width: 150, sort: false },
];

// Raw mock response that mirrors the actual `/ad-performance` API contract.
// Downstream UI code consumes the mapped rows from `adPerformanceMockRows`
// (see `mapApiAdToRow` below) so the table/charts continue to receive the
// same row shape they expect.
export const adPerformanceApiResponse = [
  {
    adId: 1,
    bannerName: "Open Enrollment Awareness",
    distributorId: 101,
    distributorName: "Brightline Benefits",
    position: 1,
    positionText: "Top",
    campaignStartDate: "2026-05-01T00:00:00.000Z",
    campaignEndDate: "2026-05-21T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 1,
    adStatusText: "Active",
    impressions: 18420,
    clicks: 742,
    ctr: 4.03,
    targetDevices: ["Mobile", "Tablet"],
    amountCharged: 1840,
  },
  {
    adId: 2,
    bannerName: "Cyber Coverage Spotlight",
    distributorId: 102,
    distributorName: "Northstar Risk Partners",
    position: 2,
    positionText: "Featured",
    campaignStartDate: "2026-04-18T00:00:00.000Z",
    campaignEndDate: "2026-05-10T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 3,
    adStatusText: "Expired",
    impressions: 9210,
    clicks: 311,
    ctr: 3.38,
    targetDevices: ["Mobile", "Windows"],
    amountCharged: 960,
  },
  {
    adId: 3,
    bannerName: "Agency Growth Toolkit",
    distributorId: 101,
    distributorName: "Brightline Benefits",
    position: 2,
    positionText: "Featured",
    campaignStartDate: "2026-05-08T00:00:00.000Z",
    campaignEndDate: "2026-05-28T00:00:00.000Z",
    paymentStatus: 1,
    paymentStatusText: "Draft",
    adStatus: 2,
    adStatusText: "Inactive",
    impressions: 0,
    clicks: 0,
    ctr: 0,
    targetDevices: ["Tablet"],
    amountCharged: 0,
  },
  {
    adId: 4,
    bannerName: "Claims Support Push",
    distributorId: 103,
    distributorName: "Keystone Advisors",
    position: 1,
    positionText: "Top",
    campaignStartDate: "2026-05-03T00:00:00.000Z",
    campaignEndDate: "2026-05-30T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 1,
    adStatusText: "Active",
    impressions: 12670,
    clicks: 596,
    ctr: 4.7,
    targetDevices: ["Mobile", "Tablet", "Windows"],
    amountCharged: 1420,
  },
  {
    adId: 5,
    bannerName: "Spring Wellness Boost",
    distributorId: 101,
    distributorName: "Brightline Benefits",
    position: 1,
    positionText: "Top",
    campaignStartDate: "2026-04-02T00:00:00.000Z",
    campaignEndDate: "2026-04-22T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 3,
    adStatusText: "Expired",
    impressions: 15780,
    clicks: 612,
    ctr: 3.88,
    targetDevices: ["Mobile", "Tablet"],
    amountCharged: 1560,
  },
  {
    adId: 6,
    bannerName: "Auto Renewal Reminder",
    distributorId: 104,
    distributorName: "Summit Insure Group",
    position: 2,
    positionText: "Featured",
    campaignStartDate: "2026-04-05T00:00:00.000Z",
    campaignEndDate: "2026-04-25T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 3,
    adStatusText: "Expired",
    impressions: 11240,
    clicks: 388,
    ctr: 3.45,
    targetDevices: ["Mobile", "Windows"],
    amountCharged: 1180,
  },
  {
    adId: 7,
    bannerName: "Small Business Bundle",
    distributorId: 102,
    distributorName: "Northstar Risk Partners",
    position: 1,
    positionText: "Top",
    campaignStartDate: "2026-04-10T00:00:00.000Z",
    campaignEndDate: "2026-05-05T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 3,
    adStatusText: "Expired",
    impressions: 20310,
    clicks: 905,
    ctr: 4.46,
    targetDevices: ["Mobile", "Tablet", "Windows"],
    amountCharged: 2050,
  },
  {
    adId: 8,
    bannerName: "Telehealth Advantage",
    distributorId: 105,
    distributorName: "Pacific Health Partners",
    position: 2,
    positionText: "Featured",
    campaignStartDate: "2026-04-15T00:00:00.000Z",
    campaignEndDate: "2026-05-15T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 1,
    adStatusText: "Active",
    impressions: 17460,
    clicks: 728,
    ctr: 4.17,
    targetDevices: ["Mobile", "Tablet"],
    amountCharged: 1720,
  },
  {
    adId: 9,
    bannerName: "Workers Comp Refresh",
    distributorId: 103,
    distributorName: "Keystone Advisors",
    position: 2,
    positionText: "Featured",
    campaignStartDate: "2026-04-20T00:00:00.000Z",
    campaignEndDate: "2026-05-12T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 3,
    adStatusText: "Expired",
    impressions: 8420,
    clicks: 245,
    ctr: 2.91,
    targetDevices: ["Windows"],
    amountCharged: 880,
  },
  {
    adId: 10,
    bannerName: "Life Insurance Awareness Week",
    distributorId: 101,
    distributorName: "Brightline Benefits",
    position: 1,
    positionText: "Top",
    campaignStartDate: "2026-04-25T00:00:00.000Z",
    campaignEndDate: "2026-05-25T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 1,
    adStatusText: "Active",
    impressions: 21580,
    clicks: 982,
    ctr: 4.55,
    targetDevices: ["Mobile", "Tablet", "Windows"],
    amountCharged: 2240,
  },
  {
    adId: 11,
    bannerName: "Flood Coverage Reminder",
    distributorId: 104,
    distributorName: "Summit Insure Group",
    position: 1,
    positionText: "Top",
    campaignStartDate: "2026-05-02T00:00:00.000Z",
    campaignEndDate: "2026-05-22T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 1,
    adStatusText: "Active",
    impressions: 14320,
    clicks: 491,
    ctr: 3.43,
    targetDevices: ["Mobile"],
    amountCharged: 1320,
  },
  {
    adId: 12,
    bannerName: "Renters Insurance Deals",
    distributorId: 106,
    distributorName: "Coastline Coverage",
    position: 2,
    positionText: "Featured",
    campaignStartDate: "2026-04-08T00:00:00.000Z",
    campaignEndDate: "2026-04-28T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 3,
    adStatusText: "Expired",
    impressions: 7850,
    clicks: 268,
    ctr: 3.41,
    targetDevices: ["Mobile", "Tablet"],
    amountCharged: 760,
  },
  {
    adId: 13,
    bannerName: "Travel Insurance Spring Sale",
    distributorId: 105,
    distributorName: "Pacific Health Partners",
    position: 1,
    positionText: "Top",
    campaignStartDate: "2026-04-12T00:00:00.000Z",
    campaignEndDate: "2026-05-02T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 3,
    adStatusText: "Expired",
    impressions: 16940,
    clicks: 712,
    ctr: 4.2,
    targetDevices: ["Mobile", "Tablet"],
    amountCharged: 1680,
  },
  {
    adId: 14,
    bannerName: "Pet Insurance Discovery",
    distributorId: 106,
    distributorName: "Coastline Coverage",
    position: 2,
    positionText: "Featured",
    campaignStartDate: "2026-05-05T00:00:00.000Z",
    campaignEndDate: "2026-05-26T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 1,
    adStatusText: "Active",
    impressions: 9870,
    clicks: 421,
    ctr: 4.27,
    targetDevices: ["Mobile"],
    amountCharged: 980,
  },
  {
    adId: 15,
    bannerName: "Disability Plan Promo",
    distributorId: 102,
    distributorName: "Northstar Risk Partners",
    position: 1,
    positionText: "Top",
    campaignStartDate: "2026-05-09T00:00:00.000Z",
    campaignEndDate: "2026-05-29T00:00:00.000Z",
    paymentStatus: 1,
    paymentStatusText: "Draft",
    adStatus: 2,
    adStatusText: "Inactive",
    impressions: 0,
    clicks: 0,
    ctr: 0,
    targetDevices: ["Mobile", "Windows"],
    amountCharged: 0,
  },
  {
    adId: 16,
    bannerName: "Dental Plan Mid-Year",
    distributorId: 103,
    distributorName: "Keystone Advisors",
    position: 1,
    positionText: "Top",
    campaignStartDate: "2026-04-22T00:00:00.000Z",
    campaignEndDate: "2026-05-18T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 1,
    adStatusText: "Active",
    impressions: 13780,
    clicks: 526,
    ctr: 3.82,
    targetDevices: ["Mobile", "Tablet"],
    amountCharged: 1380,
  },
  {
    adId: 17,
    bannerName: "Vision Care Upgrade",
    distributorId: 105,
    distributorName: "Pacific Health Partners",
    position: 2,
    positionText: "Featured",
    campaignStartDate: "2026-04-28T00:00:00.000Z",
    campaignEndDate: "2026-05-20T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 1,
    adStatusText: "Active",
    impressions: 10210,
    clicks: 372,
    ctr: 3.64,
    targetDevices: ["Mobile", "Windows"],
    amountCharged: 1040,
  },
  {
    adId: 18,
    bannerName: "Homeowners Bundle Spring",
    distributorId: 104,
    distributorName: "Summit Insure Group",
    position: 2,
    positionText: "Featured",
    campaignStartDate: "2026-04-03T00:00:00.000Z",
    campaignEndDate: "2026-04-30T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 3,
    adStatusText: "Expired",
    impressions: 19120,
    clicks: 856,
    ctr: 4.48,
    targetDevices: ["Tablet", "Windows"],
    amountCharged: 1960,
  },
  {
    adId: 19,
    bannerName: "Commercial Auto Awareness",
    distributorId: 106,
    distributorName: "Coastline Coverage",
    position: 1,
    positionText: "Top",
    campaignStartDate: "2026-05-04T00:00:00.000Z",
    campaignEndDate: "2026-05-24T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 1,
    adStatusText: "Active",
    impressions: 8650,
    clicks: 291,
    ctr: 3.36,
    targetDevices: ["Mobile", "Tablet"],
    amountCharged: 920,
  },
  {
    adId: 20,
    bannerName: "Umbrella Policy Push",
    distributorId: 101,
    distributorName: "Brightline Benefits",
    position: 2,
    positionText: "Featured",
    campaignStartDate: "2026-04-14T00:00:00.000Z",
    campaignEndDate: "2026-05-08T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 3,
    adStatusText: "Expired",
    impressions: 11890,
    clicks: 432,
    ctr: 3.63,
    targetDevices: ["Mobile", "Tablet", "Windows"],
    amountCharged: 1240,
  },
  {
    adId: 21,
    bannerName: "Cyber Liability Refresh",
    distributorId: 102,
    distributorName: "Northstar Risk Partners",
    position: 2,
    positionText: "Featured",
    campaignStartDate: "2026-05-06T00:00:00.000Z",
    campaignEndDate: "2026-05-27T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 1,
    adStatusText: "Active",
    impressions: 13540,
    clicks: 502,
    ctr: 3.71,
    targetDevices: ["Windows"],
    amountCharged: 1360,
  },
  {
    adId: 22,
    bannerName: "Group Benefits Update",
    distributorId: 103,
    distributorName: "Keystone Advisors",
    position: 1,
    positionText: "Top",
    campaignStartDate: "2026-04-18T00:00:00.000Z",
    campaignEndDate: "2026-05-09T00:00:00.000Z",
    paymentStatus: 2,
    paymentStatusText: "Purchased",
    adStatus: 3,
    adStatusText: "Expired",
    impressions: 15260,
    clicks: 631,
    ctr: 4.13,
    targetDevices: ["Mobile", "Tablet"],
    amountCharged: 1500,
  },
];

const formatCampaignDate = (isoDate) => {
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${month}/${day}/${date.getUTCFullYear()}`;
};

const toIsoDayString = (isoDate) => {
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  return date.toISOString().slice(0, 10);
};

const formatCurrency = (amount) => {
  if (!amount && amount !== 0) {
    return "";
  }
  if (Number(amount) === 0) {
    return "";
  }
  return `$${Number(amount).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

// Transforms a single API record into the row shape consumed by the data
// table, KPI cards and charts. Keys here match the `fieldName` of each entry
// in `adPerformanceColumns` so the table renders them directly.
export const mapApiAdToRow = (item) => {
  const mobileClicks = Number(item.mobileClicks) || 0;
  const tabletClicks = Number(item.tabletClicks) || 0;
  const windowsClicks = Number(item.windowsClicks) || 0;

  // Target Devices/OS isn't returned by the new API — derive it from which
  // device counters received clicks so the column still shows something
  // meaningful. Order matches the M / T / W column.
  const targetDevicesList = [];
  if (mobileClicks > 0) targetDevicesList.push("Mobile");
  if (tabletClicks > 0) targetDevicesList.push("Tablet");
  if (windowsClicks > 0) targetDevicesList.push("Windows");

  return {
    adPerformanceId: item.adId,
    bannerName: item.bannerName,
    distributorName: item.distributorName,
    position: item.positionText,
    // Column fieldName is `campaignStartDate` — value is the formatted range.
    campaignStartDate: `${formatCampaignDate(item.campaignStartDate)} - ${formatCampaignDate(item.campaignEndDate)}`,
    payment: item.paymentStatusText ?? "",
    adStatus: item.adStatusText,
    totalClicks: Number(item.totalClicks) || 0,
    targetDevices: targetDevicesList.join(", "),
    // "M / T / W" — per-device click breakdown.
    byTargetDevicesClick: `${mobileClicks} / ${tabletClicks} / ${windowsClicks}`,
    mobileClicks,
    tabletClicks,
    windowsClicks,
    amountCharged: formatCurrency(item.amountCharged),
    // Retained for KPI/chart filtering by range.
    campaignStart: toIsoDayString(item.campaignStartDate),
    campaignEnd: toIsoDayString(item.campaignEndDate),
  };
};

export const adPerformanceMockRows = adPerformanceApiResponse.map(mapApiAdToRow);

export const isAdminReportRole = (roleId) =>
  [SystemUsersEnum.SUPERADMIN, SystemUsersEnum.ADMIN].includes(Number(roleId));

export const isDistributorReportRole = (roleId) =>
  [SystemUsersEnum.DISTRIBUTOR, SystemUsersEnum.DISTRIBUTOR_INTERNAL].includes(Number(roleId));

export const isAdReportRole = (roleId) =>
  isAdminReportRole(roleId) || isDistributorReportRole(roleId);
